class DevicesDatatable {
    constructor(){
        let searchParams = new URLSearchParams(window.location.search);
        this.start = searchParams.get('start');
        this.end = searchParams.get('end');
        this.status = searchParams.get('status');
        this.organizationID = searchParams.get('organizationID');
        this.datatable = this.init('#devices-datatable', this.organizationID);
        this.initActions(this.organizationID);
        this.filterActions();
    }
    init(el, organizationID){
        const datatable =  $(el).DataTable({
            searchDelay: 400,
            processing: true,
            serverSide: true,
            stateSave: false,
            info: true,
            paging: true,
            order: [[2, 'desc']],
            ajax: {
                url: '?do=getDevices',
                type: 'POST',
                data: {
                    organizationID: organizationID
                }
            },
            searchCols: [
                null,
                null,
                null,
                { "search": (this.start && this.end ? this.start+' - '+this.end : null), "regex": false },
                { "search": (this.status ? (this.status === 'failed' ? 0 : 1) : null), "regex": false }
            ],
            language: {
                emptyTable: "No data found"
            },
            dom:
                "<'table-responsive'tr>" +
                "<'row'" +
                "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'li>" +
                "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'p>" +
                ">",
            drawCallback: function(settings) {
                // Remove all visible popovers after datatable draw
                document.querySelectorAll('.popover.fade.show').forEach(function (el) {
                    el.remove();
                });
                // Remove all visible popovers after datatable draw
                document.querySelectorAll('.popover.fade.show').forEach(function (el) {
                    el.remove();
                });
                // Init all popovers after datatable draw
                const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });
                // init page length select
                $('select[name=devices-datatable_length]').select2({minimumResultsForSearch: -1});
            },
            columns: [
                {
                    data: 'uuid',
                    title: 'Device',
                    sortable: true,
                    className: 'min-w-120px',
                    render: function (data, type, row) {
                        return '<div class="d-flex align-items-center">' +
                            '       <div class="symbol symbol-40px me-3 border ga-border-primary-300 symbol-circle">' +
                            '           <div class="symbol-label bg-light-primary border border-2 border-white overflow-hidden'+(row['isBlocked'] ? ' filter-grayscale' : '')+'">' +
                            '               <img src="/media/goodaccess/icons/os/' + row['osName'] + '.svg" alt="avatar">' +
                            '           </div>' +
                            (row['isBlocked'] ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>blocked</div>">&#10005;</span>' : '') +
                            '       </div>' +
                            '       <div class="d-flex justify-content-start flex-column">' +
                            '           <div data-cy="device-id" id="'+row['uuid']+'"><span class="fw-bold text-decoration-underline-ga primary text-primary mb-1 fs-6 '+ (row['edit'] && row['name'] ? 'edit-device' : '') +'" data-device-name="'+row['name']+'">'+row['name']+'</span></div>' +
                            '           <span class="fw-semibold d-block fs-7 ga-text-primary-800">' + row['osNameWithVersion'] +'</span>' +
                            '       </div>' +
                            '   </div>';
                    }
                },
                {
                    data: 'members',
                    title: 'Members',
                    sortable: false,
                    render: function (data, type, row) {
                        if(row['members']){
                            let html = '<div class="symbol-group symbol-hover flex-nowrap">';
                            for (let i = 0; i < row['members'].length; i++) {
                                let avatarUrl = '/media/goodaccess/avatars/svg/device.svg';
                                if (row['members'][i]['avatarID'] || row['members'][i]['isIdp']) {
                                    avatarUrl = '/media/goodaccess/avatars/svg/Icon with face-' + row['members'][i]['avatarID'] + '.svg';
                                }

                                if (i < 3) {
                                    if (row['members'][i]['password'] || row['members'][i]['isIdp']) {
                                        html += `<div class="symbol symbol-40px symbol-circle border ga-border-primary-300" id="`+row['members'][i]['uuid']+`">` +
                                            (row['editMembers'] ? '<span class="edit-member">' : '') +
                                            `        <div class="symbol-label bg-light-primary border border-2 border-white`+(row['members'][i]['isBlocked'] === 1 ? ' filter-grayscale' : '')+(!row['members'][i]['hasGateway'] ? ' opacity-50' : '')+ `" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="`+ (!row['members'][i]['isIdp'] && !row['members'][i]['avatarID'] ? `<div class='fw-bold text-center'>` + row['members'][i]['username'] + (row['members'][i]['isOwner'] ?  `<span class='badge badge-light-danger badge-sm ms-2 align-center'>Owner</span>` : ``)+(row['members'][i]['managerRole'] ? `<span class='badge badge-light-danger badge-sm ms-2 align-center'>`+row['members'][i]['managerRole']+`</span>` : ``)+(row['members'][i]['meBadge'] ? `<span class='badge badge-light-danger badge-sm ms-2 align-center'>Me</span>` : ``) + `</div>` : `<div class='fw-bold text-center'>` + row['members'][i]['name'] + (row['members'][i]['isOwner'] ?  `<span class='badge badge-light-danger badge-sm ms-2 align-center'>Owner</span>` : ``)+(row['members'][i]['managerRole'] ? `<span class='badge badge-light-danger badge-sm ms-2 align-center'>`+row['members'][i]['managerRole']+`</span>` : ``)+(row['members'][i]['meBadge'] ? `<span class='badge badge-light-danger badge-sm ms-2 align-center'>Me</span>` : ``) + `</div><div class='fw-bold text-center'>` + row['members'][i]['username'] + `</div>`) +`<div class='text-center small'>`+new IdpBadgesGenerator().generateText(row['members'][i]['idps'])+`</div>">`+
                                            '             <img alt="avatar" class="h-40px" src="' + avatarUrl + '"/>' +
                                            '        </div>' +
                                            (row['editMembers'] ? '</span>' : '') +
                                            (row['members'][i]['isBlocked'] === 1 ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>blocked</div>">&#10005;</span>' : '') +
                                            (row['members'][i]['connected'] ? '<span class="symbol-badge badge badge-circle bg-success start-85 top-85 w-15px h-15px" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>connected</div>"></span>' : '') +
                                            '     </div>';
                                    } else {
                                        html += `<div class="symbol symbol-40px symbol-circle border ga-border-primary-300">` +
                                            `        <div class="symbol-label bg-light-primary border border-2 border-white`+(row['members'][i]['isBlocked'] === 1 ? ' filter-grayscale' : '')+(!row['members'][i]['hasGateway'] ? ' opacity-50' : '')+`" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="`+ (!row['members'][i]['isIdp'] && !row['members'][i]['avatarID'] ? `<div class='fw-bold text-center'>` + row['members'][i]['username'] + (row['members'][i]['isOwner'] ?  `<span class='badge badge-light-danger badge-sm ms-2 align-center'>Owner</span>` : ``)+(row['members'][i]['managerRole'] ? `<span class='badge badge-light-danger badge-sm ms-2 align-center'>`+row['members'][i]['managerRole']+`</span>` : ``)+(row['members'][i]['meBadge'] ? `<span class="badge badge-light-danger badge-sm ms-2 align-center">Me</span>` : ``) + `</div>` : `<div class='fw-bold text-center'>` + row['members'][i]['name'] + (row['members'][i]['isBlocked'] ? ' (blocked)' : '') + (row['members'][i]['connected'] ? ' (connected)' : '') + `</div><div class='fw-bold text-center'>` + row['members'][i]['username'] + `</div>`) +`<div class='text-center small'>`+new IdpBadgesGenerator().generateText(row['members'][i]['idps'])+`</div>">`+
                                            '             <i class="fa-solid fa-user-clock fs-1 '+(row['members'][i]['isBlocked'] === 1 ? 'text-grey-700' : '')+'"></i>'+
                                            '        </div>' +
                                            (row['members'][i]['isBlocked'] === 1 ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>blocked</div>">&#10005;</span>' : '') +
                                            '     </div>';
                                    }
                                } else {
                                    html += '<div class="symbol symbol-40px symbol-circle border ga-border-primary-300" id="'+row['uuid']+'" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>'+(row['members'].length - 3)+' more Members</div>">' +
                                        '        <div class="symbol-label bg-light-primary border border-2 border-white text-primary fs-6 fw-bolder '+ (row['edit'] ? 'edit-device' : '') +'">+'+(row['members'].length - 3)+'</div>'+
                                        '     </div>';
                                    break;
                                }
                            }
                            return html+'</div>';
                        }
                        return '';
                    }
                },
                {
                    data: 'lastUpdateDate',
                    title: 'Device Info Updated',
                    className: 'min-w-90px',
                    sortable: true,
                    render: function (data, type, row) {
                        return `<span data-bs-toggle="popover" data-bs-trigger="hover" data-bs-placement="bottom" data-bs-content="${row['timezone']}">${row['lastUpdateDate']}</span>`;
                    }
                },
                {
                    data: 'lastDevicePostureCheckTime',
                    title: 'Last Posture Check',
                    sortable: true,
                    render: function (data, type, row) {
                        if(!row['lastDevicePostureCheckTime']){
                            return '';
                        }
                        return `<span data-bs-toggle="popover" data-bs-trigger="hover" data-bs-placement="bottom" data-bs-content="${row['timezone']}">${row['lastDevicePostureCheckTime']}</span>`;
                    }
                },
                {
                    data: 'lastDevicePostureCheckSuccessful',
                    title: 'Last Posture Check Result',
                    sortable: true,
                    render: function (data, type, row) {
                        if(!row['lastDevicePostureCheck'] || row['lastDevicePostureCheckSuccessful'] === null){
                            return '';
                        }

                        let numberOfFailedDpc = 0;
                        let popoverText = '';
                        for (let i in row['lastDevicePostureCheck']){
                            if(row['lastDevicePostureCheck'][i]['devicePostureCheckInfo']['isDeleted']){
                                popoverText += '<div class=\'d-flex align-items-center mb-1\'>' +
                                    '       <div class=\'symbol symbol-20px border ga-border-primary-300 text-center min-h-20px min-w-20px me-1\'>' +
                                    '           <div class=\'symbol-label bg-secondary border border-2 border-white fs-8 text-muted\'>' +
                                                    row['lastDevicePostureCheck'][i]['devicePostureCheckInfo']['name'].substring(0, 1)+
                                    '           </div>'+
                                    '       </div>'+
                                    '       <div class=\'d-flex justify-content-start flex-column\'>' +
                                    '           <div class=\'d-flex align-items-center\'>' +
                                    '               <span class=\'text-wrap text-secondary fs-6\'>'+row['lastDevicePostureCheck'][i]['devicePostureCheckInfo']['name']+'</span>' +
                                    (row['lastDevicePostureCheck'][i]['isSuccessful'] ? '<i class=\'fa-solid fa-check text-success fs-3 ms-2\'></i>' : '<i class=\'fa-solid fa-xmark text-danger fs-3 ms-2\'><span class=\'path1\'></span><span class=\'path2\'></span></i>') +
                                    '           </div>' +
                                    '       </div>' +
                                    '   </div>';
                            } else {
                                popoverText += '<div class=\'d-flex align-items-center mb-1\'>' +
                                    '       <div class=\'symbol symbol-20px border ga-border-primary-300 text-center min-h-20px min-w-20px me-1\'>' +
                                    '           <div class=\'symbol-label bg-light-primary border border-2 border-white fs-8 text-primary\'>' +
                                    (!row['lastDevicePostureCheck'][i]['devicePostureCheckInfo']['isDefault'] ? row['lastDevicePostureCheck'][i]['devicePostureCheckInfo']['name'].substring(0, 1)
                                        : '<img src=\'/media/goodaccess/logo/goodaccess-mobile.svg\' class=\'mw-15px\' alt=\'Logo\'/>')+
                                    '           </div>'+
                                    '       </div>'+
                                    '       <div class=\'d-flex justify-content-start flex-column\'>' +
                                    '           <div class=\'d-flex align-items-center\'>' +
                                    '               <span class=\'fw-bold text-wrap text-white fs-6\'>'+row['lastDevicePostureCheck'][i]['devicePostureCheckInfo']['name']+'</span>' +
                                    (row['lastDevicePostureCheck'][i]['isSuccessful'] ? '<i class=\'fa-solid fa-check text-success fs-3 ms-2\'></i>' : '<i class=\'fa-solid fa-xmark text-danger fs-3 ms-2\'><span class=\'path1\'></span><span class=\'path2\'></span></i>') +
                                    '           </div>' +
                                    '       </div>' +
                                    '   </div>';
                            }
                            if(row['lastDevicePostureCheck'][i]['reasons'] && row['lastDevicePostureCheck'][i]['reasons'].length > 0){
                                numberOfFailedDpc++;
                                popoverText += '<div class=\'d-flex flex-column fs-7 ps-7\'>';
                                for (let j in row['lastDevicePostureCheck'][i]['reasons']){
                                    popoverText += '<li class=\'d-flex align-items-center\'><span class=\'bullet me-5 bg-white\'></span>'+row['lastDevicePostureCheck'][i]['reasons'][j].replace(/"/g, '&quot;')+'</li>';
                                }
                                popoverText += '</div>';
                            }
                        }

                        if(!row['lastDevicePostureCheckSuccessful']){
                            return (row['edit'] ? '<div id="'+row['uuid']+'" class="cursor-pointer">' : '')+'<span class="badge badge-light-danger border border-danger edit-device show-logs" data-bs-toggle="popover" data-bs-trigger="hover" data-bs-placement="bottom" data-bs-html="true" data-bs-content="'+popoverText+'">' +
                                '    <i class="fa-solid fa-xmark text-danger me-1"></i> Failed <span class="ms-1">'+numberOfFailedDpc+'/'+row['lastDevicePostureCheck'].length+'</span>' +
                                '   </span>'+(row['edit'] ? '</div>' : '');
                        }

                        return (row['edit'] ? '<div id="'+row['uuid']+'" class="cursor-pointer">' : '')+'<span class="badge badge-light-success border border-success edit-device show-logs" data-bs-toggle="popover" data-bs-trigger="hover" data-bs-placement="bottom" data-bs-html="true" data-bs-content="'+popoverText+'">' +
                            '    <i class="fa-solid fa-check text-success me-1"></i> Passed <span class="ms-1">'+row['lastDevicePostureCheck'].length+'/'+row['lastDevicePostureCheck'].length+'</span>' +
                            '   </span>'+(row['edit'] ? '</div>' : '');
                    }
                },
                {
                    data: null,
                    title: 'Action',
                    sortable: false,
                    render: function (data, type, row) {
                        let html = '<div class="datatable-action min-w-3" id="'+row['uuid']+'">';
                        if (row['edit']) {
                            html += '<div class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-2 edit-device" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="Edit">' +
                                '           <span class="svg-icon svg-icon-3">' +
                                '               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                                '                   <path opacity="0.3" d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z" fill="currentColor"></path>' +
                                '                   <path d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z" fill="currentColor"></path>' +
                                '               </svg>' +
                                '           </span>' +
                                '       </div>';
                            if(row['isBlocked']){
                                html += '<div class="btn btn-icon btn-bg-light btn-sm me-2 btn-active-color-primary unblock-device cursor-pointer" data-cy="unblock-device-btn" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Unblock">'+
                                    '           <span class="svg-icon svg-icon-3">' +
                                    '               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">'+
                                    '                   <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"/>'+
                                    '                   <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor"/>'+
                                    '               </svg>' +
                                    '           </span>' +
                                    '        </div>';
                            } else {
                                html += '<div class="btn btn-icon btn-bg-light btn-sm me-2 btn-active-color-primary block-device cursor-pointer" data-cy="block-device-btn" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Block">'+
                                    '           <span class="svg-icon svg-icon-3">' +
                                    '               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">'+
                                    '                   <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"/>'+
                                    '                   <rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"/>'+
                                    '                   <rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"/>'+
                                    '               </svg>' +
                                    '           </span>' +
                                    '        </div>';
                            }
                            html += '<div class="btn btn-icon btn-bg-light btn-sm btn-active-color-primary delete-device cursor-pointer" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="Delete">'+
                                '                   <span class="svg-icon svg-icon-3">' +
                                '                       <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                                '                           <path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="currentColor"></path>' +
                                '                           <path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="currentColor"></path>' +
                                '                           <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="currentColor"></path>' +
                                '                       </svg>' +
                                '                   </span>' +
                                '               </div>';
                        }
                        return html+'</div>';
                    }
                }
            ]
        }).on('init.dt', function () {
            if(datatable.page.info().recordsTotal === 0){
                $('#devices-datatable_wrapper').hide();
                $('#devices-datatable_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
            }
        });
        // Init and add delay to datatable search
        new DatatableSearchDelay(datatable, '[data-kt-docs-table-filter=search]');
        return datatable;
    }
    initActions(organizationID){
        const thisClass = this;
        $(document).on('click', '#devices-datatable .unblock-device', function(e) {
            let deviceID = $(this).parent()[0].id;
            let deviceName = $(this).closest('tr').find('span[data-device-name]').attr('data-device-name');
            Swal.fire({
                html: `<span class="text-center text-primary">Device `+(deviceName !== undefined ? `<b>`+deviceName+`</b> ` : ``)+`is going to be unblocked!</span>`,
                icon: "warning",
                iconColor: "#FF5206",
                buttonsStyling: false,
                reverseButtons: true,
                showCancelButton: true,
                confirmButtonText: "Yes, unblock!",
                customClass: {
                    confirmButton: "btn btn-danger mt-0",
                    cancelButton: 'btn btn-light-primary mt-0',
                },
                showLoaderOnConfirm: true,
                returnFocus: false,
                preConfirm: () => {
                    return fetch('/devices?do=unblockDevice&organizationID='+organizationID+'&deviceID='+deviceID)
                        .then(response => {
                            if (!response.ok) {
                                throw new Error(response.statusText)
                            }
                            return response.json();
                        }).catch(error => {
                            Swal.showValidationMessage(`Request failed: ${error}`)
                        });
                },
                allowOutsideClick: () => !Swal.isLoading(),
                allowEscapeKey: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    if(result.value){
                        toastr.success('Device has been successfully unblocked!');
                        thisClass.datatable.ajax.reload(null, false);
                    }  else {
                        toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
                    }
                }
            });
        });
        $(document).on('click', '#devices-datatable .block-device', function(e) {
            let deviceID = $(this).parent()[0].id;
            let deviceName = $(this).closest('tr').find('span[data-device-name]').attr('data-device-name');
            Swal.fire({
                html: `<span class="text-center text-primary">Device `+(deviceName !== undefined ? `<b>`+deviceName+`</b> ` : ``)+`is going to be blocked!</span>`,
                icon: "warning",
                iconColor: "#FF5206",
                buttonsStyling: false,
                reverseButtons: true,
                showCancelButton: true,
                confirmButtonText: "Yes, block!",
                customClass: {
                    confirmButton: "btn btn-danger mt-0",
                    cancelButton: 'btn btn-light-primary mt-0',
                },
                showLoaderOnConfirm: true,
                returnFocus: false,
                preConfirm: () => {
                    return fetch('/devices?do=blockDevice&organizationID='+organizationID+'&deviceID='+deviceID)
                        .then(response => {
                            if (!response.ok) {
                                throw new Error(response.statusText)
                            }
                            return response.json();
                        }).catch(error => {
                            Swal.showValidationMessage(`Request failed: ${error}`)
                        });
                },
                allowOutsideClick: () => !Swal.isLoading(),
                allowEscapeKey: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    if(result.value){
                        toastr.success('Device has been successfully blocked!');
                        thisClass.datatable.ajax.reload(null, false);
                    }  else {
                        toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
                    }
                }
            });
        });
        $(document).on('click','#devices-datatable .delete-device',function(e){
            let deviceID = $(this).parent()[0].id;
            let deviceName = $(this).closest('tr').find('span[data-device-name]').attr('data-device-name');
            Swal.fire({
                html: `<span class="text-center text-primary">Device `+(deviceName !== undefined ? `<b>`+deviceName+`</b> ` : ``)+`is going to be completely deleted!</span>`,
                icon: "warning",
                iconColor: "#FF5206",
                buttonsStyling: false,
                reverseButtons: true,
                showCancelButton: true,
                confirmButtonText: "Yes, delete it!",
                customClass: {
                    confirmButton: "btn btn-danger mt-0",
                    cancelButton: 'btn btn-light-primary mt-0',
                },
                showLoaderOnConfirm: true,
                returnFocus: false,
                preConfirm: () => {
                    return fetch('/devices?do=removeDevice&organizationID='+organizationID+'&deviceID='+deviceID)
                        .then(response => {
                            if (!response.ok) {
                                throw new Error(response.statusText)
                            }
                            return response.json();
                        }).catch(error => {
                            Swal.showValidationMessage(`Request failed: ${error}`)
                        });
                },
                allowOutsideClick: () => !Swal.isLoading(),
                allowEscapeKey: () => !Swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    if(result.value) {
                        toastr.success('Device has been deleted.');
                        let editDeviceModal = document.getElementById('edit_device_modal');
                        if(editDeviceModal){
                            bootstrap.Modal.getOrCreateInstance(editDeviceModal).hide();
                        }
                        thisClass.datatable.ajax.reload(null, false);

                        let numberOfDevicesElement = $(".number-of-devices");
                        if(numberOfDevicesElement){
                            numberOfDevicesElement.text(numberOfDevicesElement.text() - 1);
                        }
                    } else {
                        toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
                    }
                }
            });
        });
    }
    filterActions(){
        this.initSelect2();
        this.initDateTimePicker();
        this.resetFilters();

        const thisClass = this;
        const filterButton = document.querySelector('[data-kt-docs-table-filter="filter"]');
        if(filterButton){
            filterButton.addEventListener('click', function () {
                thisClass.applyFilter();
            });
        }
        if((this.start && this.end) || this.status){
            thisClass.applyFilter();
        }
    }
    initSelect2(){
        // Format options
        const optionFormat = function (item) {
            if (!item.id) {
                return item.text;
            }

            const value = item.element.value;
            let span = document.createElement('span');
            if (value === '1') {
                span.classList.add('badge', 'badge-lg', 'badge-light-success', 'position-relative', 'px-4', 'border', 'border-success');
                span.innerText = 'Passed';
            } else {
                span.classList.add('badge', 'badge-lg', 'badge-light-danger', 'position-relative', 'px-4', 'border', 'border-danger');
                span.innerText = 'Failed';
            }

            return $(span);
        };

        $('#devicesLastDevicePostureCheckResultFilter').select2({
            templateSelection: optionFormat,
            templateResult: optionFormat,
            minimumResultsForSearch: -1
        });
        if(this.status !== null){
            $('[data-kt-docs-table-filter=lastDevicePostureCheckResult]').val(this.status === 'failed' ? 0 : 1).trigger('change');
        }
    }
    initDateTimePicker(){
        const lastUpdatedEl = $("[data-kt-docs-table-filter=lastUpdated]");
        const lastPostureCheckEl = $("[data-kt-docs-table-filter=lastPostureCheck]");

        let config = {
            autoUpdateInput: false,
            locale: {
                cancelLabel: 'Clear',
                format: "MMM D, YYYY"
            },
            ranges: {
                "Today": [moment(), moment()],
                "Yesterday": [moment().subtract(1, "days"), moment().subtract(1, "days")],
                "This Week": [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
                "Last Week": [moment().startOf('isoWeek').subtract(7, "days"), moment().endOf('isoWeek').subtract(7, "days")],
                "This Month": [moment().startOf("month"), moment().endOf("month")],
                "Last Month": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")]
            }
        };

        lastUpdatedEl.daterangepicker(config);
        lastUpdatedEl.on('apply.daterangepicker', function(ev, picker) {
            $(this).val(picker.startDate.format('MMM D, YYYY') + ' - ' + picker.endDate.format('MMM D, YYYY'));
        });
        lastUpdatedEl.on('cancel.daterangepicker', function(ev, picker) {
            $(this).val('');
        });


        if(this.start && this.end){
            config.startDate = moment(this.start, "YYYY-MM-DD hh:mm:ss");
            config.endDate = moment(this.end, "YYYY-MM-DD hh:mm:ss");
            lastPostureCheckEl.daterangepicker(config);
            lastPostureCheckEl.val(config.startDate.format('MMM D, YYYY') + ' - ' + config.endDate.format('MMM D, YYYY'));
        } else {
            lastPostureCheckEl.daterangepicker(config);
        }
        lastPostureCheckEl.on('apply.daterangepicker', function(ev, picker) {
            $(this).val(picker.startDate.format('MMM D, YYYY') + ' - ' + picker.endDate.format('MMM D, YYYY'));
        });
        lastPostureCheckEl.on('cancel.daterangepicker', function(ev, picker) {
            $(this).val('');
        });
    }
    resetFilters(){
        const thisClass = this;

        // Select reset button
        const resetButton = document.querySelector('[data-kt-docs-table-filter="reset"]');
        if(resetButton){
            // Reset datatable
            resetButton.addEventListener('click', function () {
                // Reset members and domains
                $('[data-kt-docs-table-filter=lastDevicePostureCheckResult]').val(null).trigger('change');
                // Reset Date filter
                const lastUpdatedEl = $("[data-kt-docs-table-filter=lastUpdated]");
                const lastPostureCheckEl = $("[data-kt-docs-table-filter=lastPostureCheck]");
                lastPostureCheckEl.val('');
                lastUpdatedEl.data('daterangepicker').setStartDate(moment().startOf('isoWeek'));
                lastUpdatedEl.data('daterangepicker').setEndDate(moment().endOf('isoWeek'));
                // Reset checkboxes
                $('[data-kt-docs-table-filter=unsupportedOS]').prop('checked', false);
                $('[data-kt-docs-table-filter=unsupportedApp]').prop('checked', false);

                thisClass.applyFilter(true);
            });
        }
    }
    applyFilter(reset = false){
        let numberOfActiveFilters = 0;

        if(reset){
            this.datatable.columns().search('');
        } else {
            // Select filter options
            let lastUpdated = document.querySelector('[data-kt-docs-table-filter="lastUpdated"]').value;
            let lastDevicePostureCheckResult = document.querySelector('[data-kt-docs-table-filter="lastDevicePostureCheckResult"]').value;
            let lastDevicePostureCheck = document.querySelector('[data-kt-docs-table-filter="lastPostureCheck"]').value;

            let unsupportedOS = document.querySelector('[data-kt-docs-table-filter="unsupportedOS"]').checked;
            let unsupportedApp = document.querySelector('[data-kt-docs-table-filter="unsupportedApp"]').checked;

            this.datatable.column(0).search(JSON.stringify({
                unsupportedOS: unsupportedOS
            }));
            this.datatable.column(1).search(JSON.stringify({
                unsupportedApp: unsupportedApp
            }));
            this.datatable.column(2).search(lastUpdated);
            numberOfActiveFilters += lastUpdated ? 1 : 0;
            this.datatable.column(3).search(lastDevicePostureCheck);
            numberOfActiveFilters += lastDevicePostureCheck ? 1 : 0;
            this.datatable.column(4).search(lastDevicePostureCheckResult);
            numberOfActiveFilters += lastDevicePostureCheckResult === '0' || lastDevicePostureCheckResult === '1' ? 1 : 0;

            numberOfActiveFilters += unsupportedOS ? 1 : 0;
            numberOfActiveFilters += unsupportedApp ? 1 : 0;
        }

        this.datatable.draw();

        document.getElementById('devicesNumberOfFilters').innerText = numberOfActiveFilters;
    }
}
window.DevicesDatatable = DevicesDatatable;